module.exports = "<router-outlet></router-outlet>\r\n\r\n<button class=\"fab-button\" (click)=\"showChatFunc()\" *ngIf=\"showChatButton\">\r\n    <img src=\"assets/chatbot.png\">\r\n</button>\r\n\r\n<div class=\"chat-bot\" [ngClass]=\"{opened: showChat}\">\r\n    <a class=\"close-button\" (click)=\"showChat = false\">X</a>\r\n    <iframe [src]=\"urlIframe\" *ngIf=\"urlIframe\" (load)=\"test()\"></iframe>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// d:/workspace/wynk_web_shoppings_3_prod/src/app/core/shell/shell.component.html
// module id = ../../../../../src/app/core/shell/shell.component.html
// module chunks = main